import { Tenant } from './tenant';
import { Organization } from './organization';
import { AssetRepresentation } from './asset-representation';

export class Asset {
  alias: string;
  description: string;
  latitude: number;
  longitude: number;
  timezone: string;
  technicalDetails: string;
  tenant: Tenant;
  organization: Organization;
  assetRepresentation: AssetRepresentation;
  uuid: string;
}
